import { createAsyncAction } from "typesafe-actions";
import { IError } from "..";
import { IEventStatusData } from "./types";

export const fetchEventStatus = createAsyncAction(
  "FETCH_EVENT_STATUS_START",
  "FETCH_EVENT_STATUS_SUCCESS",
  "FETCH_EVENT_STATUS_FAILURE",
)<void, IEventStatusData, IError>();
